export const languageNotSupportedModalStyles = {
  'abyss-modal-base-content-container': {
    width: '784px',
    padding: '8px, 32px, 32px, 32px',
    '@media (max-width: 744px)': {
      width: '343px',
    },
  },
  'abyss-modal-base-body': {
    maxHeight: 'max(330px, -250px + 100vh)',
    '@media (max-width: 744px)': {
      maxHeight: 'max(398px, -250px + 100vh)',
    },
  },
  '&.abyss-modal-content-title': {
    padding: '16px 0px 0px 0px',
  },

  'abyss-modal-header-container': {
    display: 'none',
  },
};

export const languageNotSupportedModalInfoStyles = {
  color: '#333333',
  padding: '0px 16px 8px 16px',
  fontSize: '18px',
  fontWeight: '400',
  textAlign: 'center',
  '@media (max-width: 744px)': {
    fontSize: '16px',
  },
};

export const languageNotSupportedModalTitleStyles = {
  '&.abyss-heading-root': {
    fontWeight: '600',
    fontSize: '28.83px',
    lineHeight: '36px',
    textAlign: 'center',
  },
};
